<div class="container-fluid">
  <!-- HEADER -->
  <div class="row pt-3 pb-2 mt-3">
    <h5 class="pl-3">
      <i class="fa fa-circle" style="color:#800000;"></i>
      Manage Access
    </h5>
  </div>

  <!-- <div class="card p-3 pb-4 mb-3 ml-3">
    <div class="row align-items-end">
      <div class="col-md-3">
        <div class="form-group mb-0">
          <label class="mb-0">Select Role:</label>
          <select class="form-control form-control-xs" name="role" [(ngModel)]="role" [compareWith]="compareById"
            (ngModelChange)="onRoleChange($event)">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let r of roleList" [ngValue]="r">
              {{ r.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group mb-0">
          <label class="mb-0">Select Service Vertical:</label>
          <select class="form-control form-control-xs" name="serviceVertical" [(ngModel)]="serviceVertical"
            [compareWith]="compareById" [disabled]="role?.name === 'Article'">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let sv of serviceVerticalList" [ngValue]="sv">
              {{ sv.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-3 d-flex align-items-center justify-content-end">
        <button type="button" class="btn btn-sm btn-outline-theme" (click)="onViewClick()">
          View Access
        </button>
      </div>

    </div>
  </div> -->

  <div class="card p-3 pb-4 mb-3 ml-0" *ngIf="!isEditMode">
    <div class="row align-items-end">

      <!-- SELECT ROLE -->
      <div class="col-md-3">
        <div class="form-group mb-0">
          <label class="mb-0">Select Role:</label>
          <select class="form-control form-control-xs" name="role" [(ngModel)]="role" [compareWith]="compareById"
            (ngModelChange)="onRoleChange($event)">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let r of roleList" [ngValue]="r">
              {{ r.name }}
            </option>
          </select>
        </div>
      </div>

      <!-- SELECT SERVICE VERTICAL -->
      <div class="col-md-3">
        <div class="form-group mb-0">
          <label class="mb-0">Select Service Vertical:</label>
          <select class="form-control form-control-xs" name="serviceVertical" [(ngModel)]="serviceVertical"
            [compareWith]="compareById" [disabled]="role?.name === 'Article'">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let sv of serviceVerticalList" [ngValue]="sv">
              {{ sv.name }}
            </option>
          </select>
        </div>
      </div>

      <!-- ACTIONS -->
      <div class="col-md-6 d-flex flex-column align-items-end">

        <!-- VIEW ACCESS -->
        <!-- <button *ngIf="isPermissionsView()" type="button" class="btn btn-sm btn-outline-theme mr-3"
          (click)="onViewClick()">
          View Access
        </button> -->
        <div class="pr-2">
          <span class="text-muted small">Select to view Permissions / Assigned Users</span>
        </div>

        <!-- PERMISSIONS / ASSIGNED USERS TOGGLE -->
        <div class="btn-group btn-group-sm">
          <button class="btn btn-sm btn-outline-theme" [ngClass]="viewMode === 'PERMISSIONS'
            ? 'btn-active-view'
            : 'btn-outline-danger'" (click)="viewMode = 'PERMISSIONS'; onViewClick()">
            Permissions
          </button>

          <button class="btn btn-sm btn-outline-theme mr-3" [ngClass]="isUsersView()
            ? 'btn-active-view'
            : 'btn-outline-danger'" (click)="viewMode = 'USERS'; fetchAssignedUsers()">
            Assigned Users
          </button>
        </div>
      </div>

    </div>
  </div>


  <!-- MAIN CONTENT -->
  <div *ngIf="isPermissionsView()">
    <div class="container ml-0" style="background-color:#ffffff;" *ngIf="accessResponse != null">
      <div *ngIf="isPermissionsView() && isEditMode" class="d-flex justify-content-start mb-3 pt-3">
        <button class="btn btn-sm" (click)="onBackToUsers()">
          <i class="fa fa-arrow-left"></i> Back to Assigned Users
        </button>
      </div>
      <div class="row mb-2">
        <div class="col-md-12 mt-1">
          <!-- <h6>
          Access Control for Role : <strong>{{ role?.name }}</strong>
          <span *ngIf="serviceVertical?.name"> | Service Vertical : <strong>{{ serviceVertical?.name }}</strong></span>
        </h6> -->
          <h6 *ngIf="!userId">
            Access Control for Role :
            <strong>{{ role?.name }}</strong>
            <span *ngIf="serviceVertical?.name">
              | Service Vertical :
              <strong>{{ serviceVertical?.name }}</strong>
            </span>
          </h6>

          <!-- <h6 *ngIf="userId">
            Access Control for User :
            <strong>{{ selectedUser?.name }}</strong>
          </h6> -->
          <div class="row mb-2 pl-3 align-items-center" style="background-color: #f8f9f9; min-height:30px;"
            *ngIf="userId">
            <div class="col-md-3">
              <h6 class="mb-0">
                Name :
                <strong>{{ selectedUser?.name }}</strong>
              </h6>
            </div>
            <div class="col-md-3">
              <h6 class="mb-0">
                Role :
                <strong>{{ role?.name }}</strong>
              </h6>
            </div>
            <div *ngIf="serviceVertical?.name" class="col-md-6">
              <h6 class="mb-0">
                Service Vertical :
                <strong>{{ serviceVertical?.name }}</strong>
              </h6>
            </div>


          </div>
          <div class="row mb-2 pl-3" *ngIf="userId">
            <div class="col-md-4">
              <div class="pr-2">
                <span class="text-muted small">* These permissions will be applied only to this user</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">

        <!-- LEFT PANEL -->
        <div class="col-md-3 pr-0">
          <div class="permission-left">

            <div class="permission-left-header">
              Permission Category
            </div>

            <div class="list-group permission-menu">
              <div *ngFor="let menu of finalMenus" class="list-group-item permission-item"
                [class.active]="menu === selectedMenu" (click)="onMenuSelect(menu)">

                {{ menu.displayName || menu.name }}

              </div>
            </div>

          </div>
        </div>

        <!-- RIGHT PANEL -->
        <div class="col-md-9">
          <div class="permission-right card" *ngIf="selectedMenu">

            <!-- HEADER -->
            <div class="permission-right card" *ngIf="selectedMenu">

  <!-- HEADER -->
 <div class="permission-header row align-items-center">

  <!-- MENU NAME -->
  <div class="col-md-3">
    <strong>{{ selectedMenu.displayName || selectedMenu.name }}</strong>
  </div>

  <!-- BRANCH LABEL (always present) -->
  <div class="col-md-2 text-right">
    <label class="mb-0" *ngIf="showBranchMultiSelect()">Branch</label>
  </div>

  <!-- BRANCH DROPDOWN (always column, condition inside) -->
  <div class="col-md-3">
    <mat-form-field
      *ngIf="showBranchMultiSelect()"
      appearance="outline"
      style="width: 100%; margin: 0;">

      <mat-select
        multiple
        [(ngModel)]="selectedBranches"
        [compareWith]="compareById"
        (selectionChange)="onBranchChange()">

        <mat-option (click)="toggleAllBranches()" [value]="0">
          Select All
        </mat-option>

        <mat-option *ngFor="let branch of branchList" [value]="branch">
          {{ branch.name }}
        </mat-option>

      </mat-select>
    </mat-form-field>
  </div>

  <!-- TOGGLE TEXT -->
  <div class="col-md-4">
    Toggle Access (On/Off)
  </div>

</div>

            <!-- MAIN MENU COMPONENTS -->
            <div *ngFor="let comp of selectedMenu.menuComponents" class="permission-row row align-items-center">

              <div class="col-md-8">
                {{ comp.name }}
              </div>

              <div class="col-md-4 text-left">
                <mat-slide-toggle class="custom-toggle" [(ngModel)]="comp.isEnabled" [disabled]="selectedMenu.isFixed"
                  (change)="toggleMenuComponent(selectedMenu); markMenuComponentModified(selectedMenu, comp)"
                  color="warn">
                </mat-slide-toggle>
                <span *ngIf="comp.isModified" class="modified-flag">
                  ● Modified
                </span>
              </div>

            </div>

            <!-- SUBMENUS -->
            <div *ngFor="let sm of selectedMenu.submenus" class="permission-row row align-items-center">

              <!-- Submenu Header -->
              <!-- <div class="permission-row row align-items-center submenu-header"> -->
              <div class="col-md-8">
                {{ sm.subMenu }}
              </div>

              <div class="col-md-4 text-left">
                <mat-slide-toggle class="custom-toggle" [(ngModel)]="sm.isEnabled"
                  (change)="toggleSubMenu(selectedMenu, sm); markSubMenuModified(selectedMenu, sm)"
                  [disabled]="selectedMenu.isFixed" color="warn">
                </mat-slide-toggle>
                <span *ngIf="sm.isModified" class="modified-flag">
                  ● Modified
                </span>
              </div>
              <!-- </div> -->

              <!-- Submenu Items -->
              <div class="col-12">
                <div *ngFor="let c of sm.subMenuComponents" class="permission-row row align-items-center submenu-item">

                  <div class="col-md-8">
                    {{ c.name }}
                  </div>

                  <div class="col-md-4 text-left">
                    <mat-slide-toggle class="custom-toggle" [(ngModel)]="c.isEnabled"
                      [disabled]="selectedMenu.isFixed || !sm.isEnabled"
                      (change)="markSubMenuComponentModified(selectedMenu, sm, c)" color="warn">
                    </mat-slide-toggle>
                    <span *ngIf="c.isModified" class="modified-flag">
                      ● Modified
                    </span>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

      <!-- FOOTER -->
      <div class="row mt-4 pb-5">
        <div class="col text-right" style="padding-right: 30px;">
          <button class="btn btn-danger mr-3" style="background-color:#800000; color:#fff; border-color:#800000;"
            (click)="onSave()" [disabled]="!hasAnyModification()">Save Changes</button>
          <button class="btn btn-outline-danger mr-2"
            style="background-color:#fff; color:#800000; border-color:#800000;" (click)="onCancel()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- SAVE CONFIRM MODAL -->
<ng-template #saveConfirmModal let-modal>
  <!-- HEADER -->
  <div class="modal-header" style="background:#800000; color:#fff; padding:0.5rem 1rem;">
    <h5 class="modal-title" style="margin:0; font-weight:700;">Save Changes</h5>
  </div>

  <!-- BODY -->
  <div class="modal-body" style="padding:1rem 3rem;">
    <!-- Role & Service Vertical -->
    <div class="row mb-2">
      <div class="col-md-6">
        <span style="font-weight:700;">Role :</span> {{ role?.name }}
      </div>
      <div class="col-md-6 text-right">
        <span style="font-weight:700;">Service Vertical :</span> {{ serviceVertical?.name || 'N/A' }}
      </div>
    </div>

    <hr />

    <!-- Changes Summary -->
    <p>
      You have made <span style="font-weight:700;">{{ modalChanges?.total }}</span> permission changes
    </p>

    <p>
      <span style="font-weight:700;">Enabled ({{ modalChanges?.enabled }})</span>
      &nbsp;&nbsp;
      <span style="font-weight:700;">Disabled ({{ modalChanges?.disabled }})</span>
    </p>

    <!-- Info Box -->
    <div *ngIf="!userId"
      style="background:#f7f7f7; padding:10px; margin-top:10px; border-radius:4px; font-size:0.9rem;">
      These changes will apply immediately to all users with this role and service vertical
    </div>
    <div *ngIf="userId" style="background:#f7f7f7; padding:10px; margin-top:10px; border-radius:4px; font-size:0.9rem;">
      These changes will apply only to this user
    </div>
  </div>

  <!-- FOOTER -->
  <div class="modal-footer" style="padding:0.75rem 1.5rem;">
    <button type="button" class="btn btn-danger" style="background:#800000; border-color:#800000; width:120px;"
      (click)="modal.close('ok')">
      OK
    </button>
    <button type="button" class="btn btn-secondary" style="width:120px;" (click)="modal.dismiss()">Cancel</button>
  </div>
</ng-template>

<!-- ASSIGNED USERS VIEW -->

<div *ngIf="viewMode === 'USERS' && assignedUsers.length > 0" class="card p-3 pb-4 mb-3 ml-3">
  <div class="row mb-3">
    <div class="col-md-12">
      <!-- <h6>
          Access Control for Role : <strong>{{ role?.name }}</strong>
          <span *ngIf="serviceVertical?.name"> | Service Vertical : <strong>{{ serviceVertical?.name }}</strong></span>
        </h6> -->
      <h6>
        Assigned Users for Role :
        <strong>{{ role?.name }}</strong>
        <span *ngIf="serviceVertical?.name">
          | Service Vertical :
          <strong>{{ serviceVertical?.name }}</strong>
        </span>
      </h6>
    </div>
  </div>

  <table class="table table-sm table-hover table-bordered custom-table-border" *ngIf="assignedUsers.length > 0">
    <thead class="thead-light">
      <tr class="text-center">
        <th>Name</th>
        <th>Reporting Partner</th>
        <th>Designation</th>
        <th>Branch</th>
        <th class="text-center">Actions</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let user of assignedUsers" class="text-left">
        <td class="pl-1">{{ user.name }}</td>
        <td class="pl-1">{{ user.reportingPartner }}</td>
        <td class="pl-1">{{ user.designation }}</td>
        <td class="pl-1">{{ user.branch }}</td>

        <td class="text-center">
          <button class="btn btn-sm btn-outline-danger mr-1" (click)="onEditUser(user)">
            <i class="fa fa-pencil"></i>
          </button>

          <!-- <button class="btn btn-sm btn-outline-danger">
            <i class="fa fa-trash"></i> -->
          <!-- </button> -->
        </td>
      </tr>
    </tbody>
  </table>

</div>